


































import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import { compositionList, getHomeSchoolList } from '../api';

Vue.use(List);

@Component
export default class SearchResult extends Vue {
  type = '';
  keyword = '';
  cate = ['参赛学校', '参赛区县', '参赛作品', '初赛入围', '决赛入围'];
  index = 0;
  result: any[] = [];
  page = 1;
  finished = false;
  loading = false;

  created() {
    this.type = this.$route.query.workType as string;
    this.keyword = this.$route.query.keyword as string;
    this.index = Number(this.$route.query.index as string);
  }
  async onGetResult() {
    if (this.finished) {
      return console.log('no more data');
    }
    this.loading = true;
    let ret: any;
    if ([0, 1].includes(this.index)) {
      // 学校区县搜索列表
      ret = await getHomeSchoolList({
        page: this.page,
        type: this.type,
        keyword: this.keyword,
      });
    } else {
      // 作文搜索列表
      ret = await compositionList({
        page: this.page,
        workType: this.type,
        search: this.keyword,
      });
    }

    this.loading = false;
    if (ret.data && ret.data.length) {
      this.page++;
      this.result = [...this.result, ...ret.data];
    } else {
      this.finished = true;
    }
  }
  htmlToText(text: string) {
    const reg = /<[^<>]+>/g; // 1、全局匹配g肯定忘记写,2、<>标签中不能包含标签实现过滤HTML标签
    text = text.replace(reg, ''); // 替换HTML标签
    text = text.replace(/&nbsp;/gi, '').replace(/^\s+|\s+$/g, ''); // 替换HTML空格
    return text;
  }
  onBack() {
    this.$router.back();
  }
}
